class CleanHeaderNavigation extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    const details = this.querySelector(':scope > details');
    const summary = details?.querySelector('summary');
    if (!details || !summary) return;
    details.addEventListener('toggle', () => {
      if (!details.open) return;
      // Keep the search panel and mobile menu from covering one another.
      if (this.matches('.och__search, .och__mobile')) {
        const header = this.closest('.och');
        header?.querySelectorAll('.och__search > details[open], .och__mobile > details[open]').forEach((other) => {
          if (other !== details) other.open = false;
        });
      }
      if (this.matches('.och__search')) this.querySelector('input[type="search"]')?.focus();
    }, { signal });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || event.defaultPrevented || !details.open) return;
      // Close an inner More dropdown before closing the mobile menu around it.
      if ([...this.querySelectorAll('details[open]')].at(-1) !== details) return;
      event.preventDefault();
      details.open = false;
      summary.focus();
    }, { signal });
    document.addEventListener('click', (event) => {
      if (details.open && !this.contains(event.target)) details.open = false;
    }, { signal });
    this.addEventListener('click', (event) => {
      if (event.target.closest('a')) details.open = false;
    }, { signal });
    const desktop = matchMedia('(min-width: 990px)');
    desktop.addEventListener('change', (event) => {
      details.open = false;
    }, { signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
  }
}

if (!customElements.get('clean-header-navigation')) {
  customElements.define('clean-header-navigation', CleanHeaderNavigation);
}
